import createAction from 'utils/redux-helpers/createAction';

const handler = (state, { name }) => state.setIn(['loading', name], false);

export const endLoading = createAction({
  action: ['endLoading', 'name'],
  handler,
});
